<div class="matrix-table-wrap">
    <div class="alert alert-warning small mb-2" *ngIf="truncated">
        ⚠ Rezultatul a fost trunchiat la limita maximă de rânduri matrice. Restrânge filtrele pentru un raport complet.
    </div>

    <table class="table table-condensed matrix-table">
        <thead>
            <tr>
                <th class="num">#</th>
                <th>Origine</th>
                <th>Destinație</th>
                <th class="num">Total</th>
                <th class="num text-progress">În lucru</th>
                <th class="num text-success">Finalizat</th>
                <th class="num text-warn">Nepreluat</th>
                <th class="num text-danger">Invalidat</th>
                <th class="num" title="Termen (intrate/interne): în termen / atenție / urgent-depășit">Termen</th>
                <th>Status doc</th>
                <th>Tip finalizare</th>
                <th>Categorii</th>
                <th>Tipuri document</th>
                <th class="num">Acțiuni</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let row of rows; let i = index">
                <tr class="matrix-row" [class.selected]="selectedRow?.drill_key === row.drill_key"
                    (click)="onRowClick(row)">
                    <td class="num">{{ i + 1 }}</td>
                    <td>
                        <strong>{{ row.origin_label }}</strong>
                        <div class="small text-muted">[{{ row.granularity_origin }}]</div>
                    </td>
                    <td>
                        <strong>{{ row.destinatie_label }}</strong>
                        <div class="small text-muted">[{{ row.granularity_destinatie }}]</div>
                    </td>
                    <td class="num"><strong>{{ row.total }}</strong></td>
                    <td class="num text-progress">{{ row.activity_breakdown.in_lucru }}</td>
                    <td class="num text-success">{{ row.activity_breakdown.finalizat }}</td>
                    <td class="num text-warn">{{ row.activity_breakdown.nepreluat }}</td>
                    <td class="num text-danger">{{ row.activity_breakdown.invalidat }}</td>
                    <td class="num term-cell">
                        <span class="term-count term-ok" title="În termen (≥10 zile)">{{ row.term_breakdown.in_termen }}</span>
                        <span class="term-count term-warn" title="Necesită atenție (5–9 zile)">{{ row.term_breakdown.atentie }}</span>
                        <span class="term-count term-danger" title="Urgent / Depășit (<5 zile)">{{ row.term_breakdown.urgent }}</span>
                    </td>
                    <td>
                        <span class="chip" *ngFor="let k of keys(row.status_doc_breakdown)">
                            {{ k }}: {{ row.status_doc_breakdown[k] }}
                        </span>
                    </td>
                    <td>
                        <span class="chip" *ngFor="let k of keys(row.tip_finalizare_breakdown)">
                            {{ k }}: {{ row.tip_finalizare_breakdown[k] }}
                        </span>
                    </td>
                    <td>
                        <span class="chip" *ngFor="let k of keys(row.categorii_breakdown)">
                            {{ k }}: {{ row.categorii_breakdown[k] }}
                        </span>
                    </td>
                    <td class="tipuri-cell">
                        <div class="tipuri-head" *ngIf="totalTypes(row) > 0">
                            <input type="text" class="tip-search" placeholder="caută tip…"
                                [value]="tipSearch[row.drill_key] || ''" (click)="$event.stopPropagation()"
                                (keydown)="$event.stopPropagation()" (input)="onTipSearch(row, $event)" />
                            <span class="tipuri-count">{{ totalTypes(row) }} tipuri</span>
                        </div>
                        <span class="chip chip-clickable" *ngFor="let t of visibleTypes(row)"
                            (click)="onChipTipClick(row, t, $event)"
                            title="Vezi documentele de acest tip pentru această pereche">
                            {{ t.name }}: {{ t.count }}
                        </span>
                        <span class="small text-muted" *ngIf="!isTipSearching(row) && hiddenTypesCount(row) > 0">
                            +{{ hiddenTypesCount(row) }} · caută
                        </span>
                        <span class="small text-muted" *ngIf="isTipSearching(row) && visibleTypes(row).length === 0">
                            fără rezultate
                        </span>
                        <span class="small text-muted" *ngIf="totalTypes(row) === 0">—</span>
                    </td>
                    <td class="num">
                        <button mat-icon-button class="expand-btn"
                            [attr.aria-label]="selectedRow?.drill_key === row.drill_key ? 'Închide' : 'Deschide'">
                            <mat-icon>
                                {{ selectedRow?.drill_key === row.drill_key ? 'expand_less' : 'expand_more' }}
                            </mat-icon>
                        </button>
                    </td>
                </tr>

                <tr *ngIf="selectedRow?.drill_key === row.drill_key" class="drill-row">
                    <td colspan="14">
                        <ng-content select="[expandedSlot]"></ng-content>
                    </td>
                </tr>
            </ng-container>

            <tr *ngIf="rows.length === 0">
                <td colspan="14" class="text-center text-muted p-3">
                    Nu există rezultate pentru filtrele selectate.
                </td>
            </tr>
        </tbody>
    </table>
</div>
